<template>
  <img
    v-if="useCustomLogo"
    class="printable-reward-link-redemption-header-logo--image"
    :src="url"
  >
  <reward-link-logo
    v-else
    :color="tangoDarkOrange"
  />
</template>

<script>
import RewardLinkLogo from '../footer/RewardLinkLogo'
import { TangoCardColors } from '@tangocard/swag'

export default {
  name: 'PrintableRewardLinkRedemptionHeaderLogo',
  components: { RewardLinkLogo },
  props: {
    url: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    useCustomLogo () {
      return !!this.url
    },
    tangoDarkOrange () {
      return TangoCardColors.orange_800
    }
  }
}
</script>

<style lang="scss">
.printable-reward-link-redemption-header-logo--image {
  max-height: 68px;
}
</style>
